import { useEffect, useState } from "react";
import { getBrowserClient } from "../../supabase/browser.ts";

export interface DerivLeg {
  id: string;
  fixture_id: string;
  home_team: string;
  away_team: string;
  league: string;
  kickoff_at: string | null;
  canonical_code: string;
  market_label: string;
  pick: string;
  odds: number;
  odds_tier: "t2" | "t3" | "t4" | "t10";
  edge: number | null;
  fair_prob: number | null;
  leg_rank: number;
  outcome: string | null;
}

export interface DerivSlip {
  slip_id: string;
  combined_odds: number;
  leg_count: number;
  status: string;
  assembled_at: string;
  legs: DerivLeg[];
}

export interface DerivPoolLeg {
  id: string;
  fixture_id: string;
  home_team: string;
  away_team: string;
  league: string;
  kickoff_at: string | null;
  canonical_code: string;
  market_label: string;
  pick: string;
  odds: number;
  odds_tier: "t2" | "t3" | "t4" | "t10";
  edge: number | null;
  fair_prob: number | null;
  source: string;
  scope: string;
}

export interface DerivBoard {
  board_date: string;
  pool_count: number;
  tier_counts: Record<string, number>;
  domestic: DerivSlip | null;
  international: DerivSlip | null;
  pool: DerivPoolLeg[];
}

export function useDerivativesBoard() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<DerivBoard | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const client = getBrowserClient() as unknown as {
          rpc: (fn: string) => Promise<{ data: unknown; error: { message: string } | null }>;
        };
        const res = await client.rpc("get_derivatives_board");
        if (!alive) return;
        if (res.error) {
          setError(res.error.message);
          return;
        }
        const d = res.data as DerivBoard | null;
        setData(d && d.board_date ? d : null);
      } catch (e) {
        if (alive) setError(e instanceof Error ? e.message : String(e));
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return { loading, data, error };
}
